import maplibregl from "maplibre-gl";
import { AppState } from "../AppState.js";

function loadHomeIcon(map: maplibregl.Map): Promise<void> {
	const svg = `<svg width="52" height="58" viewBox="0 0 52 58" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M30.966 44.3786C39.6094 42.1702 46 34.3314 46 25C46 13.9543 37.0457 5 26 5C14.9543 5 6 13.9543 6 25C6 34.3314 12.3906 42.1702 21.034 44.3786L25.2 49.9333C25.6 50.4667 26.4 50.4667 26.8 49.9333L30.966 44.3786Z"
				fill="#1B1B1F"
			/>
			<g clip-path="url(#clip0_4_4049)">
				<path
					d="M16.819 22.2975C16.569 22.5355 16.5594 22.9312 16.7974 23.1811C17.0355 23.431 17.4311 23.4407 17.681 23.2027L17.875 23.0179V32.1251C17.875 33.0455 18.6212 33.7918 19.5417 33.7918H22.6667C23.1269 33.7918 23.5 33.4186 23.5 32.9584V29.4167C23.5 27.75 24.9223 26.9167 26 26.9167C27.0778 26.9167 28.5 27.75 28.5 29.4167V32.9584C28.5 33.4186 28.8731 33.7918 29.3333 33.7918H32.4583C33.3788 33.7918 34.125 33.0455 34.125 32.1251V23.0179L34.319 23.2027C34.5689 23.4407 34.9645 23.431 35.2026 23.1811C35.4407 22.9312 35.431 22.5355 35.181 22.2975L27.1175 15.01C26.4829 14.4364 25.5171 14.4364 24.8825 15.01L16.819 22.2975Z"
					fill="white"
				/>
			</g>
		</g>
		<defs>
			<clipPath id="clip0_4_4049">
				<rect width="20" height="20" fill="white" transform="translate(16 14)" />
			</clipPath>
		</defs>
	</svg>`;

	return new Promise((resolve) => {
		const img = new Image(52, 58);
		img.onload = () => {
			map.addImage("home-marker", img);
			resolve();
		};
		img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
	});
}

export async function loadMarkerFromState(map: maplibregl.Map) {
	const state = new AppState();

	if (state.adId && state.adCoordinates) {
		await loadHomeIcon(map);

		map.addSource("ad-marker-source", {
			type: "geojson",
			data: {
				type: "FeatureCollection",
				features: [
					{
						type: "Feature",
						geometry: {
							type: "Point",
							coordinates: state.adCoordinates,
						},
						properties: {},
					},
				],
			},
		});

		map.addLayer({
			id: "ad-marker",
			type: "symbol",
			source: "ad-marker-source",
			layout: {
				"icon-image": "home-marker",
				"icon-size": 1,
				"icon-anchor": "bottom",
				"icon-allow-overlap": true,
			},
		});
	}
}
